<ng-container *ngIf="isAuthAccessibilityEnabled; else legacyInputTpl">
<div *ngIf="form" [formGroup]="form" class="form-group form-group-icon">
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
        <i class="icon-info" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <div *ngIf="label">
      <label *ngIf="label && !IsFormFieldNameHidden" [for]="inputId" [ngClass]="IsFromForm ? 'field-title':''" [id]="'label-' + inputId"> {{ label }}</label>
      <span *ngIf="label && (getErrorMessage() === requiredMessage || control.hasValidator(validator)) && !(disabled || control.disabled || isHeader)" class="text-danger" aria-hidden="true">
        *
      </span>

      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
          *ngIf="AllowMinimize" (click)="toggleText()" (keydown)="$event.preventDefault()"></i>
        <span [class.hidden-text]="!isTextVisible"class="info-text">
          {{ infoText }}
        </span>
      </span>
    </div>
  </div>

  <span *ngIf="labelHelper" class="text-muted" style="font-size: 11px"
    ><small
      ><i> {{ labelHelper }}</i></small
    ></span
  >
  <div class="form-group-control d-flex" >
    <ng-container *ngIf="!CustomFileInput">
      <ng-container *ngIf="type !== 'number'">
        <input
        #el
        [id]="inputId"
        [mask]="mask"
        [type]="type"
        class="form-control"
        [placeholder]="placeholder"
        numbersOnly
        [isNumberOnly]="type === 'number'"
        [form]="form"
        [value]="getFormControlValue()"
        [formControlName]="controlName"
        [ngClass]="{
          'is-invalid': control.dirty && control.errors,
          'color-input': type === 'color',
          'required-mark': requiredMark,
          input: disabled === true
        }"
        [attr.aria-invalid]="hasErrors() ? 'true' : null"
        [attr.aria-describedby]="getAriaDescribedby()"
        [attr.aria-required]="(control?.hasValidator(validator) || isRequired) ? 'true' : null"
        [attr.aria-label]="(type === 'date' || type === 'datetime-local') && (control?.hasValidator(validator) || isRequired) ? (label || placeholder) + ', required' : null"
        (focus)="onInputFocus()"
        (blur)="onInputBlur(); validateDateField($event)"
        (keyup)="setControlValue($event)"
        (change)="validateDateField($event)"
        [min]="getMinValue()"
        [max]="getMaxValue()"
        [attr.autocomplete]="autocomplete || null"
      />
      <span class="icon-group" *ngIf="isPasswordType">
        <button
          (click)="togglePasswordVisibility(el)"
          type="button"
          class="btn pass-hide password-view-click"
          [disabled]="disabled"
          [ngClass]="{ 'eye-icon-offset': control.dirty && control.errors }"
          [attr.aria-label]="el.type === 'password' ? 'Show password' : 'Hide password'"
          [attr.aria-pressed]="el.type === 'text'"
        >
          <span
            class="pass-custom-icon"
            [ngClass]="el.type !== 'password' ? 'icon-view-off' : 'icon-view'"
          ></span>
        </button>
      </span>
      <span class="icon-group" *ngIf="isEyeButtonVisisble()">
        <button
          (click)="showPIIData()"
          type="button"
          class="btn pass-hide password-view-click"
          [ngClass]="{ 'eye-icon-offset': control.dirty && control.errors }"
        >
          <span
            class="pass-custom-icon"
            [ngClass]="el.value !== PIIDecrypted ? 'icon-view-off' : 'icon-view'"
          ></span>
        </button>
      </span>
      <span class="icon-group" *ngIf="AllowCopy">
        <button
          (click)="copy(el.value)"
          type="button"
          class="btn pass-hide password-view-click"
          title="Copy Text"
        >
          <span
            class="icon-copy"
          ></span>
        </button>
      </span>
      </ng-container>
      <ng-container *ngIf="type === 'number' && form">
        <app-thousand-separator-input
          class="w-100"
          [id]="inputId"
          [placeholder]="placeholder"
          [disabled]="disabled"
          [isInValid]="(control.dirty && control.errors) ? true : false"
          [requiredMark]="requiredMark"
          [controlValue]="controlValue"
          [formControlName]="controlName"
          [ariaDescribedby]="getAriaDescribedby()"
          [ariaRequired]="(control?.hasValidator(validator) || isRequired) ? 'true' : null">
        </app-thousand-separator-input>
      </ng-container>
  </ng-container>
  <ng-container *ngIf="CustomFileInput">
    <ng-container *ngIf="isA11yFileInputEnabled; else legacyFileInput1">
    <div class="w-100" [class.file-input-readonly-fix]="isReadonlyFileAttachmentFixEnabled">
    <input
      [type]="type"
      id="file-input-{{form.value.Key}}-{{disabled}}"
      class="visually-hidden-a11y-input visually-hidden-input"
      [attr.disabled]="isReadonlyFileAttachmentFixEnabled && disabled ? true : null"
      [attr.aria-invalid]="hasErrors() ? 'true' : null"
      [attr.aria-describedby]="getAriaDescribedby()"
      [attr.aria-labelledby]="'label-' + inputId"
      [attr.aria-required]="isRequired ? 'true' : null"
      [(ngModel)]="selectedFile"
      [title]="(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')"
      [ngClass]="{
        'is-invalid': (control.dirty || control.touched) && control.errors,
        'color-input': false,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [ngModelOptions]="{standalone: true}"
      [attr.accept]="acceptableFileTypes"
      (change)="fileChanged($event)"
    />
    <label
     for="file-input-{{form.value.Key}}-{{disabled}}"
     class="form-control file-input-label"
     [ngClass]="{
        'is-invalid': (control.dirty || control.touched) && control.errors,
        'color-input': type === 'color',
        'required-mark': requiredMark,
        input: disabled === true,
        'csvFilePadding': isCsvFileInput,
        'file-input-disabled': isReadonlyFileAttachmentFixEnabled && disabled
      }"
      style="flex-grow: 0;"
      id="customFileInputLabel" #fileLabel
      (click)="isReadonlyFileAttachmentFixEnabled && disabled && $event.preventDefault()">
      <span id="buttonText" #filebutton class="bg-primary mr-2" [ngClass]="disabled ? 'button-disable':''">{{control.value ? 'Replace file' : 'Choose file'}}</span>
      <span class="text-muted" [ngStyle]="{ 'width': fileLabel.offsetWidth-filebutton.offsetWidth-40 + 'px'}">{{(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')}}</span>
    </label>
    </div>
    </ng-container>
    <ng-template #legacyFileInput1>
    <div class="w-100" [class.file-input-readonly-fix]="isReadonlyFileAttachmentFixEnabled">
    <label
     for="file-input-{{form.value.Key}}-{{disabled}}"
     class="form-control"
     [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'color-input': type === 'color',
        'required-mark': requiredMark,
        input: disabled === true,
        'csvFilePadding': isCsvFileInput,
        'file-input-disabled': isReadonlyFileAttachmentFixEnabled && disabled
      }"
      style="flex-grow: 0;"
      id="customFileInputLabel" #fileLabel
      (click)="isReadonlyFileAttachmentFixEnabled && disabled && $event.preventDefault()">
      <span id="buttonText" #filebutton class="bg-primary mr-2" [ngClass]="disabled ? 'button-disable':''">{{control.value ? 'Replace file' : 'Choose file'}}</span>
      <span class="text-muted" [ngStyle]="{ 'width': fileLabel.offsetWidth-filebutton.offsetWidth-40 + 'px'}">{{(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')}}</span>
    </label>
    <input
      [type]="type"
      id="file-input-{{form.value.Key}}-{{disabled}}"
      class="visually-hidden-input"
      [attr.disabled]="isReadonlyFileAttachmentFixEnabled && disabled ? true : null"
      [attr.aria-invalid]="hasErrors() ? 'true' : null"
      [attr.aria-describedby]="getAriaDescribedby()"
      [attr.aria-labelledby]="'label-' + inputId"
      [attr.aria-required]="isRequired ? 'true' : null"
      [(ngModel)]="selectedFile"
      [title]="(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'color-input': false,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [ngModelOptions]="{standalone: true}"
      [attr.accept]="acceptableFileTypes"
      (change)="fileChanged($event)"
    />
    </div>
    </ng-template>
  </ng-container>
  </div>
  <ng-container *ngIf="isA11yFileInputEnabled && CustomFileInput; else legacyError1">
  <div
    *ngIf="((control.dirty || control.touched) && control.errors) || (control.value && control.errors)"
    class="info-box error-box"
    [id]="getErrorId()"
    role="alert"
    aria-live="polite"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
  </ng-container>
  <ng-template #legacyError1>
  <div
    *ngIf="(control.dirty && control.errors) || (control.value && control.errors)"
    class="info-box error-box"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
  </ng-template>
</div>

<div *ngIf="!form" class="form-group form-group-icon">
  <div style="display: flex">
    <span
      *ngIf="infoText != null && infoText != ''"
      class="ng-binding d-flex align-items-center"
    >
      <i class="icon-info"></i>
    </span>
    <label *ngIf="label && !IsFormFieldNameHidden" [for]="inputId" [id]="'label-' + inputId">{{ label }}</label>
    <span
      *ngIf="label && (required || getErrorMessage() === requiredMessage)"
      class="text-danger"
      aria-hidden="true"
    >
      *
    </span>
  </div>
  <div class="form-group-control d-flex">
    <input
      [id]="inputId"
      [type]="type"
      class="form-control"
      [placeholder]="placeholder"
      [attr.disabled]="disabled ? true : null"
      [attr.aria-invalid]="required && !disabled ? 'true' : null"
      [attr.aria-required]="required ? 'true' : null"
    />
  </div>
</div>
</ng-container>

<ng-template #legacyInputTpl>
<div *ngIf="form" [formGroup]="form" class="form-group form-group-icon">
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
        <i class="icon-info" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <div *ngIf="label">
      <label *ngIf="label && !IsFormFieldNameHidden" [for]="inputId" [ngClass]="IsFromForm ? 'field-title':''" [id]="'label-' + inputId"> {{ label }}</label>
      <span *ngIf="label && (getErrorMessage() === requiredMessage || control.hasValidator(validator)) && !(disabled || control.disabled || isHeader)" class="text-danger" aria-hidden="true">
        *
      </span>

      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
          *ngIf="AllowMinimize" (click)="toggleText()" (keydown)="$event.preventDefault()"></i>
        <span [class.hidden-text]="!isTextVisible"class="info-text">
          {{ infoText }}
        </span>
      </span>
    </div>
  </div>

  <span *ngIf="labelHelper" class="text-muted" style="font-size: 11px"
    ><small
      ><i> {{ labelHelper }}</i></small
    ></span
  >
  <div class="form-group-control d-flex" >
    <ng-container *ngIf="!CustomFileInput">
      <ng-container *ngIf="type !== 'number'">
        <input
        #el
        [mask]="mask"
        [type]="type"
        class="form-control"
        [placeholder]="placeholder"
        numbersOnly
        [isNumberOnly]="type === 'number'"
        [form]="form"
        [value]="getFormControlValue()"
        [formControlName]="controlName"
        [ngClass]="{
          'is-invalid': control.dirty && control.errors,
          'color-input': type === 'color',
          'required-mark': requiredMark,
          input: disabled === true
        }"
        [attr.aria-invalid]="hasErrors() ? 'true' : null"
        [attr.aria-describedby]="getAriaDescribedby()"
        [attr.aria-labelledby]="'label-' + inputId"
        [attr.aria-required]="isRequired ? 'true' : null"
        [attr.aria-label]="(type === 'date' || type === 'datetime-local') && isRequired ? (label || placeholder) + ', required' : null"
        (focus)="onInputFocus()"
        (blur)="onInputBlur(); validateDateField($event)"
        (keyup)="setControlValue($event)"
        (change)="validateDateField($event)"
        [min]="getMinValue()"
        [max]="getMaxValue()"
        [attr.autocomplete]="autocomplete || null"
      />
      <span class="icon-group" *ngIf="isPasswordType">
        <button
          (mousedown)="showPassword(el)"
          (mouseup)="hidePassword(el)"
          (mouseleave)="hidePassword(el)"
          (touchstart)="showPassword(el)"
          (touchend)="hidePassword(el)"
          (touchcancel)="hidePassword(el)"
          type="button"
          class="btn pass-hide password-view-click"
          [disabled]="disabled"
          [ngClass]="{ 'eye-icon-offset': control.dirty && control.errors }"
          [attr.aria-label]="'Show password while pressed'"
          [attr.aria-pressed]="el.type === 'text'"
        >
          <span
            class="pass-custom-icon"
            [ngClass]="el.type !== 'password' ? 'icon-view-off' : 'icon-view'"
          ></span>
        </button>
      </span>
      <span class="icon-group" *ngIf="isEyeButtonVisisble()">
        <button
          (click)="showPIIData()"
          type="button"
          class="btn pass-hide password-view-click"
          [ngClass]="{ 'eye-icon-offset': control.dirty && control.errors }"
        >
          <span
            class="pass-custom-icon"
            [ngClass]="el.value !== PIIDecrypted ? 'icon-view-off' : 'icon-view'"
          ></span>
        </button>
      </span>
      <span class="icon-group" *ngIf="AllowCopy">
        <button
          (click)="copy(el.value)"
          type="button"
          class="btn pass-hide password-view-click"
          title="Copy Text"
        >
          <span
            class="icon-copy"
          ></span>
        </button>
      </span>
      </ng-container>
      <ng-container *ngIf="type === 'number' && form">
        <app-thousand-separator-input
          class="w-100"
          [id]="inputId"
          [placeholder]="placeholder"
          [disabled]="disabled"
          [isInValid]="(control.dirty && control.errors) ? true : false"
          [requiredMark]="requiredMark"
          [controlValue]="controlValue"
          [formControlName]="controlName"
          [ariaDescribedby]="getAriaDescribedby()"
          [ariaRequired]="isRequired ? 'true' : null">
        </app-thousand-separator-input>
      </ng-container>
  </ng-container>
  <ng-container *ngIf="CustomFileInput">
    <ng-container *ngIf="isA11yFileInputEnabled; else legacyFileInput2">
    <div class="w-100" [class.file-input-readonly-fix]="isReadonlyFileAttachmentFixEnabled">
    <input
      [type]="type"
      id="file-input-{{form.value.Key}}-{{disabled}}"
      class="visually-hidden-a11y-input visually-hidden-input"
      [attr.disabled]="isReadonlyFileAttachmentFixEnabled && disabled ? true : null"
      [attr.aria-invalid]="hasErrors() ? 'true' : null"
      [attr.aria-describedby]="getAriaDescribedby()"
      [attr.aria-labelledby]="'label-' + inputId"
      [attr.aria-required]="isRequired ? 'true' : null"
      (click)="disabled && !(isReadonlyFileAttachmentFixEnabled && disabled) && $event.preventDefault()"
      [(ngModel)]="selectedFile"
      [title]="(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')"
      [ngClass]="{
        'is-invalid': (control.dirty || control.touched) && control.errors,
        'color-input': false,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [ngModelOptions]="{standalone: true}"
      [attr.accept]="acceptableFileTypes"
      (change)="fileChanged($event)"
    />
    <label
     for="file-input-{{form.value.Key}}-{{disabled}}"
     class="form-control file-input-label"
     [ngClass]="{
        'is-invalid': (control.dirty || control.touched) && control.errors,
        'color-input': type === 'color',
        'required-mark': requiredMark,
        input: disabled === true,
        'csvFilePadding': isCsvFileInput,
        'file-input-disabled': isReadonlyFileAttachmentFixEnabled && disabled
      }"
      style="flex-grow: 0;"
      id="customFileInputLabel" #fileLabel
      (click)="isReadonlyFileAttachmentFixEnabled && disabled && $event.preventDefault()">
      <span id="buttonText" #filebutton class="bg-primary mr-2" [ngClass]="disabled ? 'button-disable':''">{{control.value ? 'Replace file' : 'Choose file'}}</span>
      <span class="text-muted" [ngStyle]="{ 'width': fileLabel.offsetWidth-filebutton.offsetWidth-40 + 'px'}">{{(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')}}</span>
    </label>
    </div>
    </ng-container>
    <ng-template #legacyFileInput2>
    <div class="w-100" [class.file-input-readonly-fix]="isReadonlyFileAttachmentFixEnabled">
    <label
     for="file-input-{{form.value.Key}}-{{disabled}}"
     class="form-control"
     [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'color-input': type === 'color',
        'required-mark': requiredMark,
        input: disabled === true,
        'csvFilePadding': isCsvFileInput,
        'file-input-disabled': isReadonlyFileAttachmentFixEnabled && disabled
      }"
      style="flex-grow: 0;"
      id="customFileInputLabel" #fileLabel
      (click)="isReadonlyFileAttachmentFixEnabled && disabled && $event.preventDefault()">
      <span id="buttonText" #filebutton class="bg-primary mr-2" [ngClass]="disabled ? 'button-disable':''">{{control.value ? 'Replace file' : 'Choose file'}}</span>
      <span class="text-muted" [ngStyle]="{ 'width': fileLabel.offsetWidth-filebutton.offsetWidth-40 + 'px'}">{{(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')}}</span>
    </label>
    <input
      [type]="type"
      id="file-input-{{form.value.Key}}-{{disabled}}"
      class="visually-hidden-input"
      [attr.disabled]="isReadonlyFileAttachmentFixEnabled && disabled ? true : null"
      [attr.aria-invalid]="hasErrors() ? 'true' : null"
      [attr.aria-describedby]="getAriaDescribedby()"
      [attr.aria-labelledby]="'label-' + inputId"
      [attr.aria-required]="isRequired ? 'true' : null"
      (click)="disabled && !(isReadonlyFileAttachmentFixEnabled && disabled) && $event.preventDefault()"
      [(ngModel)]="selectedFile"
      [title]="(isReadonlyFileAttachmentFixEnabled && disabled) ? 'Readonly File field' : (control.value ? control.value : 'No file chosen')"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'color-input': false,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [ngModelOptions]="{standalone: true}"
      [attr.accept]="acceptableFileTypes"
      (change)="fileChanged($event)"
    />
    </div>
    </ng-template>
  </ng-container>
  </div>
  <ng-container *ngIf="isA11yFileInputEnabled && CustomFileInput; else legacyError2">
  <div
    *ngIf="((control.dirty || control.touched) && control.errors) || (control.value && control.errors)"
    class="info-box error-box"
    [id]="getErrorId()"
    role="alert"
    aria-live="polite"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
  </ng-container>
  <ng-template #legacyError2>
  <div
    *ngIf="(control.dirty && control.errors) || (control.value && control.errors)"
    class="info-box error-box"
  >
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
  </ng-template>
</div>

<div *ngIf="!form" class="form-group form-group-icon">
  <div style="display: flex">
    <span
      *ngIf="infoText != null && infoText != ''"
      class="ng-binding d-flex align-items-center"
    >
      <i class="icon-info"></i>
    </span>
    <label *ngIf="label && !IsFormFieldNameHidden" [for]="inputId" [id]="'label-' + inputId">{{ label }}</label>
    <span
      *ngIf="label && (required || getErrorMessage() === requiredMessage)"
      class="text-danger"
      aria-hidden="true"
    >
      *
    </span>
  </div>
  <div class="form-group-control d-flex">
    <input
      [id]="inputId"
      [type]="type"
      class="form-control"
      [placeholder]="placeholder"
      [attr.disabled]="disabled ? true : null"
      [attr.aria-invalid]="required && !disabled ? 'true' : null"
      [attr.aria-required]="required ? 'true' : null"
    />
  </div>
</div>
</ng-template>
